/**
 * Calcoli del loader del pre-roll e regola di pausa del VOD durante i break.
 * Sono funzioni pure, separate da AdsVideoJs/AdsPrerollLoader, cosi' si testano senza player.
 */
const clampProgress = (progress) => Math.min(1, Math.max(0, progress));
/**
 * stroke-dashoffset dell'anello: tutta la circonferenza nascosta a 0, niente a 1.
 * Lo imposto da JS come attributo SVG numerico: su Firefox la versione CSS con calc() e var()
 * veniva scartata e l'anello restava sempre pieno.
 */
export function ringDashOffset(progress, circumference) {
    return circumference * (1 - clampProgress(progress));
}
/**
 * Percentuale intera mostrata al centro dell'anello
 */
export function formatPercent(progress) {
    return Math.round(clampProgress(progress) * 100) + "%";
}
/**
 * Punto verso cui avanza l'anello mentre si aspetta il VAST numero stepIndex (da 0) su total.
 * Si ferma al 90% del tratto del VAST: arriva al 100% solo quando l'ad e' davvero pronta.
 */
export function prerollStepTarget(stepIndex, total) {
    return (stepIndex + 0.9) / Math.max(total, 1);
}
/**
 * Valore dell'anello dopo elapsedMs di un'animazione lunga durationMs da from a to.
 * Ease-out cubica: parte veloce e rallenta, cosi' durante un VAST lento l'anello si muove ancora.
 */
export function interpolateProgress(from, to, elapsedMs, durationMs) {
    if (durationMs <= 0) {
        return to;
    }
    const time = Math.min(1, Math.max(0, elapsedMs / durationMs));
    const eased = 1 - Math.pow(1 - time, 3);
    return from + (to - from) * eased;
}
/**
 * True se un play del contenuto va annullato: il VOD resta fermo durante il waterfall del pre-roll
 * e durante ogni break; la live invece non si ferma mai (continua muta sotto l'ad)
 */
export function shouldHoldVodContent(state) {
    return !state.isLive && (state.prerollPending || state.breakActive);
}
